<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="viewer-container">
    <div class="viewer-content">
      <PrimeToolBar class="sticky consultation-toolbar">
        <template #start>
          <h3 v-if="contentNode" class="consultation-title">
            {{ contentNode.name }}
          </h3>
          <PrimeTag
            v-if="$route.params.versionId"
            class="tag-version"
            :value="$route.params.versionId"
          />
        </template>
        <template #end>
          <PrimeButton
            v-tooltip.bottom="$t(`download`)"
            :aria-label="$t('download')"
            icon="ri-download-line"
            severity="warning"
            class="download-btn"
            raised
            @click="download()"
          />
        </template>
      </PrimeToolBar>
      <div class="video-container">
        <video
          v-if="contentUrl"
          :key="contentUrl"
          controls
          class="video-rendition"
        >
          <source :src="contentUrl" />
        </video>
      </div>
    </div>
  </div>
</template>
<script>
import Tag from "primevue/tag";
import ToolBar from "primevue/toolbar";
import Button from "primevue/button";
import Tooltip from "primevue/tooltip";

export default {
  name: "VideoPlayer",
  components: {
    PrimeTag: Tag,
    PrimeToolBar: ToolBar,
    PrimeButton: Button,
  },
  directives: {
    tooltip: Tooltip,
  },
  props: {
    canUpload: {
      type: Boolean,
      default: false,
    },
    contentUrl: {
      type: String,
      default: null,
    },
    contentNode: {
      type: Object,
      default: null,
    },
  },
  emits: ["reload"],
  computed: {
    isVersion() {
      return (
        this.$route.params.versionId !== null &&
        this.$route.params.versionId !== undefined
      );
    },
  },
  methods: {
    reload() {
      this.$emit("reload");
    },
    download() {
      const link = document.createElement("a");
      link.href = this.contentUrl;
      link.download = this.contentNode.name;
      link.click();
    },
  },
};
</script>
<style lang="scss" scoped>
.viewer-container {
  display: flex;
}

.viewer-content {
  flex-grow: 1;
  overflow: auto;
}

.consultation-toolbar {
  width: 100%;
}

.consultation-title {
  margin: 0;
}

.download-btn {
  margin-right: 0.5rem;
}

.video-container {
  display: flex;
  justify-content: center;
  margin-right: 0.25rem;
  border: 1px solid var(--p-surface-200);
  border-radius: var(--p-border-radius);
  background-color: var(--p-surface-0);
  padding: 1rem;
}

.video-rendition {
  display: block;
  margin: auto;
  max-width: 59vw;
  @media (width < 60em) {
    max-width: 80vw;
  }
  @media (width < 35em) {
    max-width: 65vw;
  }
}
</style>
